import { type UseMutationOptions, type UseQueryOptions, useMutation, useQuery } from '@tanstack/react-query'
import type { AxiosInstance } from 'axios'
import { deleteProfile, getProfile, patchProfile } from './auth'
import type { UserProfile } from './types'

export const QUERY_KEYS = {
  PROFILE: ['auth', 'profile'],
} as const

export const useProfileQuery = (
  client: AxiosInstance,
  options?: Omit<UseQueryOptions<UserProfile>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.PROFILE,
    queryFn: () => getProfile(client),
    ...options,
  })
}

export const useUpdateProfileMutation = (
  client: AxiosInstance,
  options?: Omit<UseMutationOptions<UserProfile, Error, Partial<UserProfile>>, 'mutationFn'>,
) => {
  return useMutation({
    mutationFn: (profile: Partial<UserProfile>) => patchProfile(client, profile),
    ...options,
  })
}

export const useDeleteProfileMutation = (
  client: AxiosInstance,
  options?: Omit<UseMutationOptions<{ message: string }, Error, void>, 'mutationFn'>,
) => {
  return useMutation({
    mutationFn: () => deleteProfile(client),
    ...options,
  })
}
